import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { FC } from 'react';

export interface EmptyStateProps {
  className?: string;
  text?: string | React.ReactNode;
  iconName?: TIconName;
}

const EmptyState: FC<EmptyStateProps> = (props) => {
  const {
    className,
    text = 'No results found',
    iconName = 'search-refraction.3',
  } = props;

  return (
    <div
      className={
        'flex flex-col items-center' + (className ? ' ' + className : '')
      }
    >
      <UntitledIcon
        className="h-8 w-8 text-job-brand"
        name={iconName}
        vectorEffect={'non-scaling-stroke'}
      />
      <div className="mt-2 text-base">{text}</div>
    </div>
  );
};

export const AccessDeniedState = (props: EmptyStateProps) => {
  const {
    text = "You don't have permission",
    iconName = 'alert-triangle.3',
    ...rest
  } = props;

  return <EmptyState text={text} iconName={iconName} {...rest} />;
};

export default EmptyState;
